import React from 'react';
import { Container } from './styles';
import NewsCard from 'common/NewsCard/NewsCard';
import Button from '../../components/Buttom/Button';
import INews from 'interfaces/INews';
import SubTitle from 'common/SubTitle/SubTitle';
import { useHistory } from 'react-router';
import { formatDate } from 'utils/string';

interface Props {
  news?: INews[];
}

const News = (props: Props): JSX.Element => {
  const { news } = props;
  const history = useHistory();

  if (!news || news.length === 0) return <></>;

  const mainNews = news.find(n => n.location === 'newsMain');

  const newsOne = news.find(n => n.location === 'newsOne' || n.location === 'newsTwo');

  const mostRecentNews =
    !newsOne &&
    [...news]
      .filter(n => n.status === 'published')
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())[0];

  const displayedNewsOne = newsOne || mostRecentNews;

  return (
    <Container>
      <SubTitle text="Notícias" />
      <ul>
        {mainNews && (
          <NewsCard
            key={mainNews.id}
            img={mainNews.image}
            dateStr={formatDate(mainNews.date)}
            title={mainNews.title}
            description={mainNews.description}
            slug={mainNews.slug ?? ''}
          />
        )}

        {displayedNewsOne && (
          <NewsCard
            key={displayedNewsOne.id}
            img={displayedNewsOne.image}
            dateStr={formatDate(displayedNewsOne.date)}
            title={displayedNewsOne.title}
            description={displayedNewsOne.description}
            slug={displayedNewsOne.slug ?? ''}
          />
        )}
      </ul>
      <Button text="ver todas as notícias" onClick={() => history.push('news')} />
    </Container>
  );
};

export default News;
